import { LettersDashboard } from './LettersDashboard';
import { CreateLetterSelection } from './CreateLetterSelection';
import { CreateLetterPage } from './CreateLetterPage';
import { ViewTemplatesPage } from './ViewTemplatesPage';
import { UploadPdfLetterPage } from './UploadPdfLetterPage';
import { ViewLettersPage } from './ViewLettersPage';
import { PendingApprovalPage } from './PendingApprovalPage';
import { LettersAdminPage } from './LettersAdminPage';
import { LettersRoleAssignmentPage } from './LettersRoleAssignmentPage';
import { LettersAddSignaturePage } from './LettersAddSignaturePage';
import { useAuth } from '../../context/AuthContext';
import { isAdminFlag } from '../../utils/helpers';

interface LetterGenerationModuleProps {
  page?: string;
  onNavigate?: (page: string) => void;
}

export function LetterGenerationModule({
  page = 'dashboard',
  onNavigate,
}: LetterGenerationModuleProps) {
  const { user } = useAuth();
  const canAccessAdminPages =
    isAdminFlag(user?.permissions?.is_admin) || user?.email?.toLowerCase() === 'vikas@surbhi.net';
  // Permissions arrive from the SSO cookie as MySQL tinyints (1/0), not booleans,
  // so these must go through isAdminFlag — a strict `=== true` check silently denied
  // every freshly-granted user.
  const canCreateTemplate =
    canAccessAdminPages ||
    isAdminFlag(user?.permissions?.can_create_letters) ||
    isAdminFlag(user?.permissions?.can_view_letters);

  if (page === 'create') return <CreateLetterSelection />;
  if (page === 'create-fresh') return <CreateLetterPage />;
  if (page === 'create-template') {
    if (!canCreateTemplate) return <div className="p-8 text-red-600">Access denied.</div>;
    return <CreateLetterPage mode="template" />;
  }
  if (page === 'view-templates') return <ViewTemplatesPage />;
  if (page === 'upload-pdf') {
    return <UploadPdfLetterPage />;
  }
  if (page === 'view') return <ViewLettersPage defaultStatus="" pageTitle="View Letters" />;
  if (page === 'drafts') return <ViewLettersPage defaultStatus="draft" pageTitle="View Drafts" />;
  if (page === 'pending-approval') return <PendingApprovalPage />;
  if (page === 'admin') {
    if (!canAccessAdminPages) return <div className="p-8 text-red-600">Access denied.</div>;
    return <LettersAdminPage onNavigate={(nextPage) => onNavigate?.(nextPage)} />;
  }
  if (page === 'role-assignment') {
    if (!canAccessAdminPages) return <div className="p-8 text-red-600">Access denied.</div>;
    return <LettersRoleAssignmentPage />;
  }
  if (page === 'add-signature') {
    if (!canAccessAdminPages) return <div className="p-8 text-red-600">Access denied.</div>;
    return <LettersAddSignaturePage onNavigate={(nextPage) => onNavigate?.(nextPage)} />;
  }
  return <LettersDashboard />;
}
